import { ref } from 'vue'

const snackbar = ref(false)
const snackText = ref('')
const snackColor = ref('secondary')

export function useSnackbar() {
  function showSnackbar(message, color = 'secondary') {
    snackText.value = message
    snackColor.value = color
    snackbar.value = true
  }

  return {
    snackbar,
    snackText,
    snackColor,
    showSnackbar
  }
}